import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseDeliveryLinesPickup = () => {
  const deliveryLinesPickup = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/delivery-lines/pickup', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { deliveryLinesPickup }
}

export default InteractorWarehouseDeliveryLinesPickup
